<div>
  <div class="lf-label" [innerHTML]="label"></div>
  @if (value) {
    <div class="lf-value" [innerHTML]="value"></div>
  } @else {
    <div class="lf-value"> &nbsp; </div>
  }
</div>
